/**
 * Saturated background colors used by Auth0's static letter avatars
 * (`https://cdn.auth0.com/avatars/{initials}.png`). Auth0 picks the color from
 * the first letter of the initials only (X and Y share one swatch).
 *
 * Colors were sampled from the CDN PNGs — do not invent a parallel palette.
 */
const AUTH0_AVATAR_COLORS: Readonly<Record<string, string>> = {
  a: '#1abc9c',
  b: '#16a085',
  c: '#f1c40f',
  d: '#f39c12',
  e: '#2ecc71',
  f: '#27ae60',
  g: '#e67e22',
  h: '#d35400',
  i: '#3498db',
  j: '#2980b9',
  k: '#e74c3c',
  l: '#c0392b',
  m: '#9b59b6',
  n: '#8e44ad',
  o: '#bdc3c7',
  p: '#34495e',
  q: '#2c3e50',
  r: '#95a5a6',
  s: '#7f8c8d',
  t: '#ec87bf',
  u: '#d870ad',
  v: '#f69785',
  w: '#9ba37e',
  x: '#b49255',
  y: '#b49255',
  z: '#a94136',
}

const FALLBACK = AUTH0_AVATAR_COLORS.u

/** Background hex for initials, matching Auth0's first-letter palette. */
export function auth0AvatarBackground(initials: string): string {
  const first = initials.trim().charAt(0).toLocaleLowerCase('en-US')
  if (!first || !/[a-z]/.test(first)) {
    return FALLBACK
  }
  return AUTH0_AVATAR_COLORS[first] ?? FALLBACK
}
